import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { SchoolProvider } from '../context/SchoolContext'
import { SchoolSidebar } from '../components/SchoolSidebar'
import { useCurrentUser } from '../hooks/useCurrentUser'
import { useMixpanelIdentify } from '../hooks/useMixpanelIdentify'

export const Route = createFileRoute('/school/$schoolId')({
  component: SchoolLayout,
})

function SchoolLayout() {
  const { schoolId } = Route.useParams()
  const navigate = useNavigate()
  const { data: user, isLoading } = useCurrentUser()

  useMixpanelIdentify(user)

  useEffect(() => {
    if (!isLoading && (!user || user.tenantType !== 'school' || user.tenantId !== schoolId)) {
      navigate({ to: '/login' })
    }
  }, [isLoading, user, schoolId, navigate])

  if (isLoading || !user || user.tenantType !== 'school') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-page-bg">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-brand" />
      </div>
    )
  }

  return (
    <SchoolProvider
      value={{
        schoolId,
        schoolName: user.schoolName ?? 'School',
        staffRole: user.schoolStaffRole ?? 'staff',
      }}
    >
      <div className="flex min-h-screen bg-page-bg">
        <SchoolSidebar />
        <main className="flex-1 lg:ml-0">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <Outlet />
          </div>
        </main>
      </div>
    </SchoolProvider>
  )
}
